import { UPDATE_POSITIONS } from './actions';

import HTTP from './../lib/HTTP';

const state = {};

const mutations = {};

const actions = {
    [UPDATE_POSITIONS](context, data){
        return new Promise((resolve, reject) => {
            HTTP.post('positions/update', data).then(res => {
                console.log(res);
                resolve(res);
            }).catch(err => {
                console.log(err);
                reject(err);
            })
        });
    }
//   [LOG_IN](context, data) {
//     return new Promise((resolve, reject) => {
//       HTTP.post('sessions', data).then((res) => {
//         if (res && res.status === 200 && res.data && res.data.token) {
//           Authorization.setToken(res.data.token, data.remember);
//         }

//         resolve(res);
//       }).catch((err) => {
//         reject(err);
//       });
//     });
//   },
};

export default {
  state,
  mutations,
  actions,
};
